export default "__VITE_ASSET__DFxW8caR__"